"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _auth = require("@/utils/auth");
var _storeEdit = _interopRequireDefault(require("./components/storeEdit"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate.js");
var _scannerDialog = _interopRequireDefault(require("@/views/store/components/scannerDialog.vue"));
var _virtualSalesSetting = _interopRequireDefault(require("./components/virtualSalesSetting.vue"));
var _UploadModal = _interopRequireDefault(require("./components/UploadModal.vue"));
var _UploadHistoryModal = _interopRequireDefault(require("./components/UploadHistoryModal.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'ProductList',
  components: {
    storeEdit: _storeEdit.default,
    ScannerDialog: _scannerDialog.default,
    VirtualSalesDialog: _virtualSalesSetting.default,
    UploadModal: _UploadModal.default,
    UploadHistoryModal: _UploadHistoryModal.default
  },
  data: function data() {
    return {
      direction: 'rtl',
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      // roterPre: roterPre,
      headeNum: [],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        cateId: '',
        keywords: '',
        type: '1'
      },
      categoryList: [],
      merCateList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '商品图', '商品名称', '商品售价', '销量', '库存', '排序', '状态', '操作时间'],
      columnData: ['ID', '商品图', '商品名称', '商品售价', '销量', '库存', '排序', '状态', '操作时间'],
      isIndeterminate: true,
      drawer: false,
      productId: 0,
      multipleSelection: []
    };
  },
  mounted: function mounted() {
    this.goodHeade();
    this.getList();
    this.getCategorySelect();
    this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
  },
  methods: {
    checkPermi: _permission.checkPermi,
    sucess: function sucess() {
      this.$message.success('保存成功');
      this.drawer = false;
      this.getList();
      this.goodHeade();
    },
    handleCloseEdit: function handleCloseEdit() {
      this.drawer = false;
    },
    handleStock: function handleStock(row) {
      this.productId = row.id;
      this.drawer = true;
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.cateId = '';
      this.tableFrom.keywords = '';
      this.goodHeade();
      this.resetSelections();
      this.getList();
    },
    //恢复商品
    handleRestore: (0, _validate.Debounce)(function (id) {
      var _this = this;
      this.$modalSure('恢复商品').then(function () {
        (0, _store.restoreApi)(id).then(function (res) {
          _this.$message.success('操作成功');
          _this.goodHeade();
          _this.getList();
        });
      });
    }),
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.resetSelections();
      this.getList();
      this.goodHeade();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleCloseMod: function handleCloseMod(item) {
      this.dialogVisible = item;
      this.goodHeade();
      this.getList();
    },
    // 复制
    onCopy: function onCopy() {
      this.$router.push({
        name: 'SortCreat',
        params: {
          isCopy: 1
        }
      });
    },
    // 导出
    exports: function exports() {
      (0, _store.productExcelApi)({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this2 = this;
      (0, _store.productHeadersApi)(this.tableFrom).then(function (res) {
        _this2.headeNum = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    },
    // 列表
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _store.productLstApi)(this.tableFrom).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
        _this4.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this5 = this;
      this.$modalSure(this.tableFrom.type === '5' ? "\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1\u5417\uFF1F") : "\u5C06 id \u4E3A ".concat(id, " \u7684\u5546\u54C1\u52A0\u5165\u56DE\u6536\u7AD9\u5417\uFF1F")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _store.productDeleteApi)(id, deleteFlag).then(function () {
          _this5.$message.success('操作成功');
          if (_this5.tableData.data.length === 1 && _this5.tableFrom.page > 1) _this5.tableFrom.page = _this5.tableFrom.page - 1;
          _this5.getList();
          _this5.goodHeade();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this6 = this;
      row.isShow ? (0, _store.putOnShellApi)(row.id).then(function () {
        _this6.$message.success('上架成功');
        _this6.getList();
        _this6.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : (0, _store.offShellApi)(row.id).then(function () {
        _this6.$message.success('下架成功');
        _this6.getList();
        _this6.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    renderHeader: function renderHeader(h) {
      var _this7 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this7.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    onOpenScanDialog: function onOpenScanDialog() {
      this.$refs.scannerDialogRef.openDialog();
    },
    onselectionchange: function onselectionchange(val) {
      this.multipleSelection = val;
    },
    resetSelections: function resetSelections() {
      this.multipleSelection = [];
      this.$refs.tableRef.clearSelection();
    },
    onOpenVirtualSalesDialog: function onOpenVirtualSalesDialog() {
      this.$refs.virtualSalesRef.openDialog(this.multipleSelection);
    },
    onVirtualUpdateSuccess: function onVirtualUpdateSuccess() {
      this.resetSelections();
      this.getList();
    },
    handleImportCommand: function handleImportCommand(command) {
      switch (command) {
        case "history":
          this.$refs.uploadHistoryModalRef.open();
          break;
      }
    },
    onOpenImportDialog: function onOpenImportDialog() {
      this.$refs.uploadModalRef.open();
    }
  }
};